// 方法配置
import Vue from 'vue'
import API from '@/api/api'

const Vthis = new Vue()

export default {
    //处理腾讯云上传的key
    handleUploadKey: (path, filename) => {
        console.log(path, filename, '处理腾讯云上传的key');
        let dateTime = new Date();
        let Y = dateTime.getFullYear(),
            M = dateTime.getMonth() + 1,
            D = dateTime.getDate(),
            H = dateTime.getHours(),
            Mi = dateTime.getMinutes(),
            S = dateTime.getSeconds(),
            Ms = dateTime.getMilliseconds();
        Y = Y.toString();
        M = M < 10 ? ('0' + M) : M;
        D = D < 10 ? ('0' + D) : D;
        H = H < 10 ? ('0' + H) : H;
        Mi = Mi < 10 ? ('0' + Mi) : Mi;
        S = S < 10 ? ('0' + S) : S;
        let timestamp = (dateTime.getTime()).toString();
        let UUID = Vthis.uuid(12).replace(/\-/g, '');
        // let KEY = path + Y + M + D + '_' + timestamp + '_' + UUID + Vthis.$config.hadleFileName(filename)
        // 去除空格
        // let fileN = 'filename'.replace(/\s/g, '');
        // let KEY = path + Y + M + D + '_' + H+Mi+S+Ms + '_' + UUID + fileN
        let KEY = path + Y + M + D + '_' + H+Mi+S+Ms + '_' + UUID + Vthis.$config.hadleFileName(filename)
        return KEY
    },
    hadleFileName: (filename) => {
        //处理文件名得到后缀 如 .jpg .png等
        let filename_ = filename.split('.');
        let filenameEnd = filename_[filename_.length - 1];
        filenameEnd = filenameEnd.toLowerCase()
        let endStr = '.' + filenameEnd;
        return endStr
    },
    obtainUploadCos: ($this, ref, path) => {
        return new COS({
            getAuthorization: function (options, callback) {
                let params = {};
                params.path = path;
                /*sendAjax('get',`tencent/uploadedToken/${path}`,params).then(res => {
                    let data = res.data;
                    console.log(res,'ddd')
                    callback({
                        TmpSecretId: data.credentials.tmpSecretId,
                        TmpSecretKey: data.credentials.tmpSecretKey,
                        XCosSecurityToken: data.credentials.sessionToken,
                        ExpiredTime: data.expiredTime
                    });
                }).catch(error => {
                    $this.$message.error('上传失败')
                    $this.$refs[ref].visible = true;
                })*/
                API.tencentUploadToken(params).then(res => {
                    let data = res.data;
                    console.log(res, 'resres');
                    callback({
                        TmpSecretId: data.credentials.tmpSecretId,
                        TmpSecretKey: data.credentials.tmpSecretKey,
                        XCosSecurityToken: data.credentials.sessionToken,
                        ExpiredTime: data.expiredTime
                    })
                }).catch(err => {
                    console.log(err, 'cw');
                    $this.$message.error('上传失败')
                    $this.$refs[ref].visible = false;


                })
            }
        })
    },
    handleListDelPage: (pagination, delNum) => {
        //处理分页列表 的删除问题
        let { c_total, c_size, c_page } = pagination;

        // console.log(c_total, 'c_total', c_size, 'c_size', c_page, 'c_page', delNum, 'delNum');
        if (!delNum) delNum = 1
        // console.log(delNum, 'delNum2');
        c_total = c_total - delNum;
        // console.log(c_total, c_size);
        let page = Math.ceil(c_total / c_size);
        if (page == 0) {
            return 1
        }
        if (c_page <= page) {
            return c_page
        } else {
            return page--
        }
    },
    formValidatePhone:(rule, value, callback)=>{
        //验证表单手机号
        console.log(rule, value);
        let sss =  Vthis.$config.phoneReg.test(value)
        if (!sss) {
            callback(new Error('请输入正确格式的手机号'));
            // callback('请输入正确的积分');
        } else {
            callback()
        }
    },
    formValidatePassword:(rule, value, callback)=>{
        //验证表单密码
        console.log(rule, value);
        let sss =  Vthis.$config.passwordReg.test(value)
        if (!sss) {
            callback(new Error('请输入正确格式的密码'));
            // callback('请输入正确的积分');
        } else {
            callback()
        }
    },
    authorityJudge: (needRole) => {
        //权限判断
        // console.log(needRole, 'needRole');
        //token 信息
        let tokenInfo = Vthis.$config.analysisToken();
        // console.log(tokenInfo, 'tokenInfo');
        let userRole = tokenInfo.userRole ? tokenInfo.userRole : [];
        //判断用户是否存在需要的角色
        let isInclude = false;
        for (let item of needRole) {
            isInclude = userRole.includes(item)
            if (isInclude) break
        }
        // console.log(isInclude, 'isIncludeisInclude');
        return isInclude
    },


}
